/* Suprimal problem → agitate → solution band (snippets/sp-pas): keeps the CTA price and plan in step with the plan picked in the buy box. */
(function () {
  function init(root) {
    if (!root || root.__pas) return;
    root.__pas = 1;
    /* the CTA submits the buy box form, so show the price and plan picked there */
    var form = document.getElementById(root.getAttribute('data-form'));
    var price = root.querySelector('[data-pas-price]'), plan = root.querySelector('[data-pas-plan]'), day = root.querySelector('[data-pas-day]'), row = root.querySelector('[data-pas-planrow]');
    if (form) {
      var sync = function () {
        var r = form.querySelector('.sp-option input[type=radio]:checked');
        var o = r && r.closest ? r.closest('.sp-option') : null;
        if (!o) return;
        if (price && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
        if (plan) plan.textContent = o.getAttribute('data-plan') || '';
        if (day) day.textContent = o.getAttribute('data-day') || '';
        if (row) row.hidden = !(o.getAttribute('data-plan') && o.getAttribute('data-day'));
      };
      form.addEventListener('change', sync);
      sync();
    }
  }
  function all() { [].forEach.call(document.querySelectorAll('[data-sp-pas]'), init); }
  all();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();